import React from 'react';
import { useTranslation } from 'react-i18next';
import ComparePage from './ComparePage';

const BANKS = [
  {
    name: 'RBC',
    cardName: 'RBC Cash Back Mastercard',
    cardData: {
      bank: 'RBC',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '0.5% cash back on all purchases, up to 1% on groceries',
    },
  },
  {
    name: 'Desjardins',
    cardName: 'Desjardins Cash Back Visa',
    cardData: {
      bank: 'Desjardins',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: 'Up to 1% cash back in BONUSDOLLARS on purchases',
    },
  },
];

const ROWS = [
  { label: 'Cuota anual', values: ['Sin cuota', 'Sin cuota'] },
  { label: 'Cash back', values: ['Hasta 1% en supermercados', 'Hasta 1% en BONUSDOLLARS'] },
  { label: 'Programa newcomer', values: ['Si - RBC Newcomer Package', 'Si - programa para recien llegados'] },
  { label: 'App movil', values: ['RBC Mobile - 4.0/5', 'Desjardins Mobile - 3.5/5'] },
  { label: 'Soporte en espanol', values: ['Parcial', 'Parcial + frances nativo'] },
  { label: 'Presencia en Quebec', values: ['Buena - sucursales en Montreal y Quebec City', 'Excelente - cooperativa quebecoise, red mas grande en Quebec'] },
  { label: 'Solidarity Tax Credit', values: ['N/A - es un beneficio de Revenu Quebec', 'Facil acceso con cuenta Desjardins'] },
  { label: 'Productos RRSP/TFSA', values: ['Amplia gama', 'Amplia gama + fonds Desjardins'] },
];

const FAQS = [
  {
    question: 'Soy latino en Quebec, RBC o Desjardins?',
    answer: 'Si vives en Quebec, Desjardins tiene una ventaja por ser la cooperativa financiera mas grande de la provincia con la red de sucursales mas extensa. Sin embargo, RBC ofrece mejor soporte digital y es ideal si planeas mudarte a otra provincia en el futuro.',
  },
  {
    question: 'Desjardins ofrece servicios en espanol?',
    answer: 'Desjardins ofrece servicios principalmente en frances e ingles. No tienen linea dedicada en espanol, pero algunas sucursales en Montreal tienen personal hispanohablante. Si el espanol es prioridad, considera Scotiabank o TD.',
  },
  {
    question: 'Puedo recibir mi Solidarity Tax Credit en Desjardins?',
    answer: 'Si. El Solidarity Tax Credit se deposita directamente en tu cuenta bancaria. Cualquier banco canadiense funciona, pero muchos residentes de Quebec prefieren Desjardins por la integracion con servicios provinciales y la facilidad de acceso.',
  },
];

const RELATED = [
  { to: '/comparar/rbc-vs-td-recien-llegados', label: 'RBC vs TD para recien llegados' },
  { to: '/comparar/scotiabank-vs-bmo-inmigrantes', label: 'Scotiabank vs BMO para recién llegados' },
  { to: '/comparar/mejores-bancos-recien-llegados-canada-2026', label: 'Mejores bancos para recien llegados 2026' },
];

const RbcVsDesjardinsPage = () => {
  const { i18n } = useTranslation();
  return (
  <ComparePage
    seoTitle="RBC vs Desjardins en Quebec 2026"
    seoDescription="RBC vs Desjardins para latinos en Quebec. Comparacion de tarjetas, sucursales, soporte en espanol, Solidarity Tax Credit y FinMaple Score."
    seoKey="compararRbcDesj"
    noIndex={i18n.language !== 'es'}
    canonical="/comparar/rbc-vs-desjardins-quebec"
    routeKey="compararRbcDesj"
    breadcrumbLabel="RBC vs Desjardins Quebec"
    atomicAnswer="En Quebec, Desjardins domina con la red de sucursales mas grande de la provincia y productos adaptados al contexto quebecois. RBC ofrece mejor experiencia digital y es mejor opcion si planeas mudarte fuera de Quebec. Ambos aceptan newcomers."
    banks={BANKS}
    comparisonRows={ROWS}
    veredicto="Para latinos viviendo en Quebec, Desjardins es ligeramente mejor si planeas quedarte en la provincia - su red de sucursales es imbatible y la integracion con servicios locales es superior. Sin embargo, si valoras la experiencia digital y la portabilidad nacional (por si te mudas a Ontario u otra provincia), RBC es la opcion mas segura. Ambos ofrecen tarjetas sin cuota para recien llegados."
    faqs={FAQS}
    mayaText="Vives en Quebec y no sabes que banco elegir? Preguntale a Maya - conoce los beneficios de cada banco para tu situacion."
    relatedLinks={RELATED}
  />
  );
};

export default RbcVsDesjardinsPage;
